module.exports = __webpack_public_path__ + "static/media/election.5bb776bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/election.png
// module id = 63
// module chunks = 0